import Cookies from 'js-cookie'
import Vue from 'vue'

export function getCurTmpEnv() {
  return Cookies.get('X-PROJ-NAME-TMP')
}

export function getCurDefaultEnv() {
  return Cookies.get('X-PROJ-NAME')
}

export function parseEnv(envStr) {
  try {
    const rawProd = envStr.split('##')
    return {
      name: rawProd[0],
      env: rawProd[1],
      version: rawProd[2],
      ossUrl: rawProd[3]
    }
  } catch (err) {
    return {}
  }
}

function isLoginPage(curUrl) {
  const url = decodeURIComponent(curUrl)
  const isLoginPage = /#\/user\/login/.test(url)
  return isLoginPage
}

function getTargetUrl(curUrl) {
  const isLogin = isLoginPage(curUrl)
  if (isLogin) {
    const url = decodeURIComponent(curUrl)
    const pat = /#\/user\/login\?(.*)redirect=(.*)/
    const matches = pat.exec(url)
    if (matches && matches.length >= 3) {
      return matches[2]
    } else {
      return '/'
    }
  }

  return curUrl
}

export function handleEnvChange(headers = {}) {
  if (process.env.VUE_APP_DISABLE_AB_ENV === 'y') {
    // 环境配置禁用 ab 环境切换
    return
  }

  if (!window.reloadAppVersion) {
    // 不是ab环境, 无法切换
    return
  }

  const targetTmpEnv = headers['x-wdt-project']
  if (!targetTmpEnv || targetTmpEnv === "''" || targetTmpEnv === getCurTmpEnv()) {
    // 不需要跳转
    return
  }

  if (isLoginPage(window.location.href)) {
    // 登录页面, 且需要跳转环境
    // 本次不要跳转, 等登录逻辑走完后,再进行跳转环境逻辑
    Vue.ls.set('abEnvNextEnv', targetTmpEnv)
    return
  }

  const envObj = parseEnv(targetTmpEnv)
  window.reloadAppVersion && window.reloadAppVersion(envObj.env, envObj.version, envObj.ossUrl, getTargetUrl(window.location.href))
}

export function getEnvToHeader() {
  const tmpEnv = getCurTmpEnv()
  if (!tmpEnv) {
    return ''
  }

  const envObj = parseEnv(tmpEnv)
  return envObj.env || ''
}
